<h2 mat-dialog-title>Select Status</h2>

<mat-dialog-content>
  <p *ngIf="!data.statuses || data.statuses.length === 0" class="no-statuses-message">
    No statuses available.
  </p>

  <mat-form-field *ngIf="data.statuses && data.statuses.length > 0" appearance="outline" class="status-select-field">
    <mat-label>Target Status</mat-label>
    <mat-select [(ngModel)]="selectedStatus" required name="statusSelect">
      <mat-option *ngFor="let status of data.statuses" [value]="status">
        {{ status.name }}
      </mat-option>
    </mat-select>
    </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancelClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirmClick()" [disabled]="!selectedStatus">Confirm</button>
</mat-dialog-actions>